import React from 'react'
import { Alert, Button } from '@mote/ui'
import { useAccountSubscriptionPortalMutation } from '@mote/api'
import styled from 'styled-components'

export const AccountManageSubscription = () => {
  const { mutate, data, loading, error, flush } =
    useAccountSubscriptionPortalMutation()

  const errorMessage = React.useMemo(() => {
    if (!data && !error) return null

    if (data.error) return data.error?.message

    if (error)
      return 'Something went wrong. Please try again and if the problem persists kindly contact support.'
  }, [error, data])

  React.useEffect(() => {
    if (!data) return
    if (error) return

    if (data.URL) {
      window.location.href = data.URL
    }
  }, [data, error])

  function getPortalUrl() {
    flush()
    mutate()
  }

  return (
    <Root>
      {errorMessage && <Alert type='error' message={errorMessage} />}

      <Button
        text='Manage subscription'
        onClick={getPortalUrl}
        loading={loading}
      />
    </Root>
  )
}

const Root = styled.div`
  margin-bottom: 20px;
`
